import styled from 'styled-components';

export const LinkWrap = styled.div`
    top: 0;
    left: 0;
    z-index: 9999;
    padding: 15px;
    background: #fff;
    position: absolute;
    box-shadow: 0 0 15px 0 rgba(43, 53, 86, 0.15);
    border: 1px solid ${({ theme }) => theme.borderPaleGrey};
`;

export const Label = styled.label`
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 7px;
    display: inline-block;
`;

export const Input = styled.input`
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.borderPaleGrey};
`;
